const styles = () => ({
    root: {},
    grow: {
        flex: "1"
    },
    light: {
        fontWeight: 300
    },
    bold: {
        fontWeight: 500
    },
    bolder: {
        fontWeight: 600
    },
    regular: {
        fontWeight: "unset"
    },
    italic: {
        fontStyle: "italic"
    },
    xs: {
        fontSize: 10
    },
    sm: {
        fontSize: 12
    },
    md: {
        fontSize: 14
    },
    lg: {
        fontSize: 16
    },
    xlg: {
        fontSize: 18
    },
    xl: {
        fontSize: 20
    },
    xxl: {
        fontSize: 24
    },
    xxxl: {
        fontSize: 32
    },
    link: {
        cursor: "pointer",

        "&:hover": {
            color: "#003080"
        }
    },
    underline: {
        textDecoration: "underline"
    },
    blue: {
        color: "#1D4ED8"
    },
    darkBlue: {
        color: "#013c61"
    },
    gray: {
        color: "#64748b"
    },
    placeholder: {
        color: "rgba(0,0,0,.45)"
    },
    black: {
        color: "#0f172a"
    },
    lightGray: {
        color: "gainsboro"
    },
    darkGray: {
        color: "#4C4673"
    },
    orange: {
        color: "#FF5722"
    },
    hoverOrange: {
        "&:hover": {
            color: "#FF5722"
        }
    },
    darkgreen: {
        color: "#023B2A"
    },
    danger: {
        color: "red"
    },
    white: {
        color: "white"
    },
    darkSuccess: {
        color: "#aaffaa"
    },
    success: {
        color: "#3c763d"
    },
    halfPaddingLeft: {
        paddingLeft: 4
    },
    paddingRight: {
        paddingRight: 8
    },
    halfPaddingRight: {
        paddingRight: 4
    },

    nowrap: {
        whiteSpace: "nowrap"
    },
    textCenter: {
        textAlign: "center",
        display: "inline-block"
    },
    textLeft: {
        textAlign: "left"
    },
    textRight: {
        textAlign: "right"
    },
    uppercase: {
        textTransform: "uppercase"
    },
    lowercase: {
        textTransform: "lowercase"
    },
    capitalize: {
        textTransform: "capitalize"
    },
    spacing2: {
        letterSpacing: 2
    },
    spacing4: {
        letterSpacing: 4
    },
    onClick: {
        cursor: "pointer"
    },
    noUnderlined: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "none"
        }
    },
    warning: {
        color: "#9d7900"
    },
    left: {
        minWidth: 32
    },
    lineThrough: {
        textDecoration: "line-through"
    },
    bold700: {
        fontWeight: 700
    },
    paddingLeft: {
        paddingLeft: 8
    }
});

export default styles;
